import { render, staticRenderFns } from "./GmbServiceChangeItem.vue?vue&type=template&id=25c5b56a&scoped=true&"
import script from "./GmbServiceChangeItem.vue?vue&type=script&lang=js&"
export * from "./GmbServiceChangeItem.vue?vue&type=script&lang=js&"
import style0 from "./GmbServiceChangeItem.vue?vue&type=style&index=0&id=25c5b56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5b56a",
  null
  
)

export default component.exports